import { useState, useEffect, useContext } from 'react';
import { Row, Col, Card, Table, Badge, Form, InputGroup, Button, Modal } from 'react-bootstrap';
import { FaSearch, FaEye, FaBan, FaCheckCircle, FaTimesCircle } from 'react-icons/fa';
import '../../../assets/css/Admin/AllCustomers/AllCustomer.css';
import AdminMasterLayout from '../../../layouts/Admin/AdminMasterLayout';
import axios from 'axios';
import AppContext from '../../../context/AppContext';


const AllCustomer = () => {
  const { baseUrl, authToken } = useContext(AppContext);
  const [customers, setCustomers] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');

  const filteredCustomers = customers.filter(customer =>
    customer.customerName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    customer.customerEmail?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    customer.mobileNumber?.includes(searchTerm)
  );

  const getStatusBadge = (status) => {
    switch (status) {
      case 'Active':
        return 'success';
      case 'Inactive':
        return 'warning';
      case 'Blocked':
        return 'danger';
      default:
        return 'secondary';
    }
  };
  const handleViewCustomer = (customer) => {
    setSelectedCustomer(customer);
    setShowModal(true);
  };
  useEffect(() => {
    axios.post(`${baseUrl}/admin/users/viewAllCustomers`, {}, {
      headers: { Authorization: `Bearer ${authToken}` },
    }).then((response) => {
      if (response.data.success === true) {
        setCustomers(response.data.customers);
      }
    }).catch((error) => console.log(error));
  }, []);
  return (
    <AdminMasterLayout screenName="customers">
      <div className="all-customer-container">

        {/* Page Header */}
        <div className="all-customer-header">
          <div className="all-customer-header-content">
            <h1 className="all-customer-page-title">All Customers</h1>
            <p className="all-customer-page-subtitle">Manage and view all registered customers</p>
          </div>
          <div className="all-customer-stats-summary">
            <div className="all-customer-stat-item">
              <span className="all-customer-stat-label">Total Customers</span>
              <span className="all-customer-stat-value">{customers.length}</span>
            </div>
            <div className="all-customer-stat-item">
              <span className="all-customer-stat-label">Active</span>
              <span className="all-customer-stat-value all-customer-stat-active">
                {customers.filter(c => c.status === 'Active').length}
              </span>
            </div>
          </div>
        </div>

        {/* Search and Filter Section */}
        <Row className="mb-3">
          <Col lg={12}>
            <Card className="all-customer-search-card">
              <Card.Body className="all-customer-search-body">
                <InputGroup className="all-customer-search-group">
                  <InputGroup.Text className="all-customer-search-icon">
                    <FaSearch />
                  </InputGroup.Text>
                  <Form.Control
                    type="text"
                    placeholder="Search by name, email or phone..."
                    className="all-customer-search-input"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                  />
                </InputGroup>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        {/* Customers Table */}
        <Row className="all-customer-table-row">
          <Col lg={12}>
            <Card className="all-customer-table-card">
              <Card.Body className="all-customer-table-body">
                <div className="all-customer-table-wrapper">
                  <Table className="all-customer-table">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>CUSTOMER NAME</th>
                        <th>EMAIL</th>
                        <th>PHONE</th>
                        <th>REGISTRATION DATE</th>
                        <th>TOTAL RIDES</th>
                        <th>STATUS</th>
                        <th>ACTIONS</th>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredCustomers.length > 0 ? (
                        filteredCustomers.map((customer, index) => (
                          <tr key={customer.id}>
                            <td>{index + 1}</td>
                            <td>
                              <div className="all-customer-info">
                                <div className="all-customer-avatar">{customer.avatar}</div>
                                <span className="all-customer-name">{customer.customerName}</span>
                              </div>
                            </td>
                            <td className="all-customer-email">{customer.customerEmail}</td>
                            <td>{customer.mobileNumber}</td>
                            <td>{new Date(customer.created_at).toLocaleDateString()}</td>
                            <td>
                              <span className="all-customer-rides-count">{customer.tdrides?.length || 0}</span>
                            </td>
                            <td>
                              <Badge
                                bg={getStatusBadge(customer.status)}
                                className="all-customer-status-badge"
                              >
                                {customer.status === 'Active' && <FaCheckCircle className="all-customer-status-icon" />}
                                {customer.status === 'Inactive' && <FaTimesCircle className="all-customer-status-icon" />}
                                {customer.status === 'Blocked' && <FaBan className="all-customer-status-icon" />}
                                {customer.status}
                              </Badge>
                            </td>
                            <td>
                              <div className="all-customer-action-buttons">
                                <Button className="all-customer-view-btn" size="sm" onClick={() => handleViewCustomer(customer)}>
                                  <FaEye /> View
                                </Button>
                                {customer.status !== 'Blocked' && (
                                  <Button
                                    className="all-customer-block-btn"
                                    size="sm"
                                    title="Block Customer"
                                  >
                                    <FaBan /> Block
                                  </Button>
                                )}
                              </div>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="8" className="all-customer-no-data">
                            No customers found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
        <Modal show={showModal} onHide={() => setShowModal(false)} size="lg" centered>
          <Modal.Header closeButton>
            <Modal.Title><FaEye className="me-2" /> Customer Details</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {selectedCustomer && (
              <div>
                <h3>{selectedCustomer.customerName}</h3>
                <p>{selectedCustomer.customerEmail}</p>
                <p>Phone: {selectedCustomer.mobileNumber}</p>
                <p>Coins: {selectedCustomer.customerCoins}</p>
                <p>Total Rides: {selectedCustomer.tdrides?.length || 0}</p>
                <p>Status: {selectedCustomer.status}</p>
              </div>
            )}
          </Modal.Body>
        </Modal>

      </div>
    </AdminMasterLayout>
  );
};

export default AllCustomer;